module.exports = __webpack_public_path__ + "static/media/pic05.faeb33fc.svg";